import { isEmpty } from 'lodash'

import { projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, isValidPhone, macroCacheOptions, request } from '@/utils'

import { dictionaryToService } from '@/components/services/dictionaries/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedCreate = Cache.wrapWithCache(async (key, service, params) => {
  return await request.create(`/${service}/search`, { body: params })
})

export default {
  name: 'LocalSearch',

  props: {
    dictionary: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      searchQuery: undefined,
      searchResult: undefined,

      loading: false,
      empty: false
    }
  },

  watch: {
    searchQuery(searchQuery) {
      if (isEmpty(searchQuery)) {
        this.searchResult = undefined
        this.empty = false
      }
    }
  },

  computed: {
    validation() {
      return isValidPhone(this.searchQuery)
    }
  },

  methods: {
    async search() {
      if (this.loading) {
        return
      }

      try {
        if (this.validation) {
          this.loading = true
          this.empty = false
          this.searchResult = undefined
          const service = dictionaryToService(this.dictionary.type)
          const key = [ projectName, service, 'create', this.dictionary.id, this.dictionary.OwnerId, this.searchQuery ].filter(Boolean).join(':')
          const data = await cachedCreate(key, service, {
            id: this.dictionary.id,
            OwnerId: this.dictionary.OwnerId,
            value: this.searchQuery
          })
          if (!isEmpty(data)) {
            this.searchResult = data
          } else {
            this.empty = true
          }
        }
      } catch (error) {
        globalErrorHandler(error)
        this.empty = true
      } finally {
        this.loading = false
      }
    }
  },

  render
}
